'use strict';
const mmWidgets = require('./mm-widgets'),
	addHotkey = require('./add-hotkey');
mmWidgets.fn.showHotkeyWidget = function (target) {
	return mmWidgets.each(this, function () {
		const element = this,
			activateOnHotkeys = element.attr('data-mm-show-hotkey');
		addHotkey(target, activateOnHotkeys, function (e) {
			if (element.hasClass('hidden')) {
				e.stopPropagation();
				e.preventDefault();
				element.removeClass('hidden');
			}
		});
	});
};
